import { Indicator } from 'mint-ui'
export default class Dep {
  constructor () {
    this.subs = new Map()
  }

  /**
   * 因为要保证唯一性，所有使用Map结构存储
   *map.set(key, vlaue)
   * @param {*} array
   * @memberof Dep
   */
  addSub (key, value) {
    this.subs.set(key, value)
  }
  getKey (key) {
    return this.subs.has(key)
  }
  /**
   *
   * 移除订阅
   * @param {*} key
   * @memberof Dep
   */
  removeSub (key) {
    this.subs.delete(key)
  }

  /**
   *
   * 发布订阅
   * 发布完成之后，会将订阅室清空
   * @memberof Dep
   */
  async notify () {
    const subs = this.subs.values()
    return new Promise(resolve => {
      Indicator.open()
      for (let sub of subs) {
        sub()
      }
      Indicator.close()
      this.subs = new Map()
      resolve()
    })
  }
}
